import { invoiceTotals, round2, type InvoiceLine } from "./invoiceCalc";
import { parseNumber } from "../converters/numberInput";

/**
 * Receipt totals with the unit price rounded to cents FIRST, so the printed "qty x price = amount" lines always add up to
 * the printed subtotal. `refund` turns every line into a credit (the receipt total is negative).
 */
export function receiptTotals(items: InvoiceLine[], taxPct: string, refund = false) {
  const rounded = items.map((i) => {
    const p = parseNumber(String(i.unitPrice ?? "").replace(/[$€£¥₹]/g, ""));
    return { ...i, unitPrice: p === null ? i.unitPrice : String(round2(p)), credit: refund };
  });
  return invoiceTotals(rounded, "0", taxPct);
}

/** Message for the first line with a quantity or price that is not allowed, else null. Negative numbers need Refund mode. */
export function receiptLineProblem(items: InvoiceLine[]): string | null {
  for (let i = 0; i < items.length; i++) {
    const x = items[i];
    if (!x.description.trim() && !x.quantity.trim() && !x.unitPrice.trim()) continue;
    const q = parseNumber(x.quantity);
    if (q !== null && q < 0) return `Line ${i + 1} has a negative quantity. For a refund, tick "Refund receipt" and enter positive numbers.`;
    if (q !== null && q === 0) return `Line ${i + 1} has a quantity of 0.`;
    const p = parseNumber(String(x.unitPrice).replace(/[$€£¥₹]/g, ""));
    if (p !== null && p < 0) return `Line ${i + 1} has a negative price. For a refund, tick "Refund receipt" and enter positive numbers.`;
  }
  return null;
}

/** True when the text has an emoji or pictograph, which the PDF fonts cannot draw. */
export const hasEmoji = (s: string) => /[\u2190-\u2BFF\uD83C-\uDBFF]/.test(s);
